import { Component, OnInit ,Input ,HostListener ,Output ,EventEmitter, OnDestroy, ChangeDetectorRef} from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import {CategoryItem, mainRestaurantItem} from 'src/app/models/category';
import { ChangeFood} from 'src/app/models/restaurant'
import { AppProxy } from 'src/app/services/app-proxy';
import { BussinssService } from 'src/app/services/bussinss-service';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-restaurant-search-list',
  templateUrl: './restaurant-search-list.component.html',
  styleUrls: ['./restaurant-search-list.component.css']
})
export class RestaurantSearchListComponent implements OnInit {
  // @Input()items: CategoryItem[];
  @Output()changeShowPrice: EventEmitter<number> = new EventEmitter<number>();
  @Output()changByFood: EventEmitter<number> = new EventEmitter<number>();
  // buffer: CategoryItem[] = [];
  loading: boolean;
  restaurantsItem:mainRestaurantItem[]=[];
  // restaurantsItemAll:CategoryItem[]=[];
  // category:Category;
  changeFood:ChangeFood[];
  //id:number=-1;
  text:string;
  categoryName="";
  num=0;
  page:number=1;
  sum = 100;
  throttle = 100;
  scrollDistance = 1;
  scrollUpDistance = 2;
  direction = "";
  categoryId:number;
  listId:number;
  showProgress=false;
  previousUrl:string;
  private routeSub: Subscription;
  random:number;
  private searchSubscription: Subscription;
  private roterSubscription: Subscription;
  private isDestroyed = false; 


  // ngOnDestroy() {
  //   this.isDestroyed = true; 
  //   if (this.searchSubscription) {
  //     this.searchSubscription.unsubscribe();
  //     this.roterSubscription.unsubscribe();
  //   }
  // }
  backPress()
{
  localStorage.back='true'

  let a=location.pathname;

} 

  onScrollDown() {
    
    this.appendItems();
    this.direction = "down";
  }

  onUp() {
    this.sum += 20;
    this.prependItems();
    this.direction = "up";
  }

  prependItems() {
    //if(this.restaurantsItem.length>0)
    //this.addItems();
  }

  appendItems() {
   // if(this.restaurantsItem.length>0 )
   // this.addItems();
  }



  constructor(private cd: ChangeDetectorRef, private router: Router,private proxy:AppProxy, private route: ActivatedRoute,private dataService:DataService, private bussinssService:BussinssService) {
    
   }

ngOnInit(): void {
  // Initialize localStorage and sessionStorage
  localStorage.setItem('back', 'false');
  localStorage.setItem('Category', '2');
  sessionStorage.setItem('CATEGORY_FILTER', '0');
  
  // Reset scroll position
  window.scroll(0, 0);

  // Reset data service states
  this.dataService.byFood.next(false);
  this.changByFood.emit();
  this.dataService.show.next(false);
  this.changeShowPrice.emit();

  // Subscribe to route param changes
  this.route.params.subscribe(params => {
    this.text = params['text'] || '';
    this.page = 1;
    if (this.text) {
      this.showProgress = true;
      this.performSearch();
    }
  });
}

private performSearch(): void {
  if (!this.text) {
    return;
  }
  
  
  
  this.bussinssService.getMenuBySearch(this.text, this.page).subscribe({
    next: (res: any[]) => {
      // this.bussinssService.setGlobalSearch(this.text);
      this.showProgress = false;

      if (this.page == 1)
      {
        this.restaurantsItem = []
        this.restaurantsItem = res;
      }
      else
      {
         this.restaurantsItem.push(...res)
      }
   
      
    
      this.categoryName = this.text;
      // this.dataService.search.next('');
      console.log('Search completed');

         if (res.length == 12)
      {
          this.page += 1
         this.performSearch()
      }
    },
    error: (error) => {
      this.showProgress = false;
      console.error('Search error:', error);
      // Handle error appropriately (show user message, etc.)
    }
  });
}

  onClickCategory(id:number){
    localStorage.ID = id.toString();
   }


}

